export enum FileInputSubmissionMode {
    AUTO_SUBMIT, MANUAL_SUBMIT
}
